import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import domain from '../../constants/config.js';

const apiUrl = domain.API_BASE_URL+'v1/vehicle-lists';



export const fetchVehicles = createAsyncThunk(apiUrl, async () => {
  const response = await axios.get(`${apiUrl}`);
  console.log("response store",response);
  return response.data;
});

const vehicleListSlice = createSlice({
  name: 'vehicleList',
  initialState: {
    data:[],
    apiResponse: [],
    loading: false, // default false
    apiErrorMsg: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVehicles.pending, (state) => {
        state.loading = true; // pending is triggered → sets loading = true
        console.log("state3",state.loading);
      })
      .addCase(fetchVehicles.fulfilled, (state, action) => {
        state.loading = false;

        //Apply custom sort before saving to state
        const sortedList = {
          data: action.payload.data.sort((a, b) => {
            if (a.vehicle_type_id === 2 && b.vehicle_type_id !== 2) return -1;
            if (b.vehicle_type_id === 2 && a.vehicle_type_id !== 2) return 1;
            if (a.vehicle_type_id === 1 && b.vehicle_type_id !== 1) return -1;
            if (b.vehicle_type_id === 1 && a.vehicle_type_id !== 1) return 1;
            return 0;
          })
        };
        
        state.apiResponse = sortedList; //API call completes → fulfilled sets list = response.data
        console.log("Reducer apiResponse",state.apiResponse);
      })
      .addCase(fetchVehicles.rejected, (state, action) => {
        state.loading = false;
        state.apiErrorMsg = action.error.message; // If it fails → rejected sets error = message
      });
  },
});

export default vehicleListSlice.reducer;